import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-trends-header-component',
  templateUrl: './trends-header-component.component.html',
  styleUrls: ['./trends-header-component.component.scss']
})
export class TrendsHeaderComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
